import React from 'react';
import { BRAND_MARK_SRC, PRODUCT_NAME } from '../brand';
import './AuthFlowShell.css';

interface AuthFlowShellProps {
  children: React.ReactNode;
  busy?: boolean;
}

export const AuthLoadingCard: React.FC = () => (
  <div className="auth-flow-card auth-flow-loading-card" aria-live="polite">
    <div className="auth-flow-brand" aria-label={PRODUCT_NAME}>
      <img className="auth-flow-brand-mark" src={BRAND_MARK_SRC} alt="" aria-hidden="true" />
      <span>{PRODUCT_NAME}</span>
    </div>
    <div className="auth-flow-spinner" aria-hidden="true" />
    <p className="auth-flow-eyebrow">Preparing workspace</p>
    <h1 className="auth-flow-title">Loading your account</h1>
  </div>
);

const AuthFlowShell: React.FC<AuthFlowShellProps> = ({ children, busy = false }) => (
  <div className="auth-flow-shell" data-theme="dark" aria-busy={busy || undefined}>
    <div className="auth-flow-panel">
      {children}
    </div>
  </div>
);

export default AuthFlowShell;
